export default __webpack_public_path__ + "static/media/Head_3_Ear_3_C4.b79a0119.svg";